import { render, staticRenderFns } from "./ProductReviewsScore.vue?vue&type=template&id=07eade80&scoped=true&"
import script from "./ProductReviewsScore.vue?vue&type=script&lang=js&"
export * from "./ProductReviewsScore.vue?vue&type=script&lang=js&"
import style0 from "./ProductReviewsScore.vue?vue&type=style&index=0&id=07eade80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07eade80",
  null
  
)

export default component.exports